export default [{
  text: 'Created at',
  value: 'created_at',
  width: '110px'
}, {
  text: 'Price contract ID',
  value: 'contract.id',
  apiSort: 'contract_id',
}, {
  text: 'Business',
  value: 'business.name',
  apiSort: 'businesses.name',
}, {
  text: 'Legal business name',
  value: 'legal_business_name',
  apiSort: 'billing_accounts.legal_business_name',
}, {
  text: 'Estimated amount',
  value: 'amount.subtotal',
  apiSort: 'payment_amounts.subtotal',
  isCurrency: true,
}, {
  text: 'Discount',
  value: 'amount.discount',
  apiSort: 'payment_amounts.discount',
  isPercent: true,
}, {
  text: 'CAP discount',
  value: 'amount.cap_percent',
  apiSort: 'payment_amounts.cap_percent',
  isPercent: true,
}, {
  text: 'Final amount',
  value: 'amount.total',
  apiSort: 'payment_amounts.total',
  isCurrency: true,
}, {
  text: 'Status',
  value: 'status.name',
  apiSort: 'status',
}];
